import { Link } from 'react-router-dom'
import type { IndexDef } from '@/api/types/readiness'
import { Chip, Icon } from '@/components/readiness/primitives'
import { isPreliminary } from '@/lib/readiness/scale'

// Preliminary presentation rules (I2 §11.4): a full-width notice under the
// header on every page of a preliminary index, never rendered without it.
export function PreliminaryNotice({ index }: { index: IndexDef }) {
  if (!isPreliminary(index) || !index.preliminary) return null
  return (
    <div className="mb-4 flex flex-wrap items-start gap-2 rounded-[10px] px-4 py-3 text-[12.5px]" style={{ background: 'var(--rd-status-warn-bg)', color: 'var(--rd-text-secondary)' }} role="note" data-testid="preliminary-notice">
      <Icon name="info" size={14} className="mt-0.5 shrink-0" style={{ color: 'var(--rd-status-warn)' }} />
      <p className="min-w-0 flex-1">
        <b style={{ color: 'var(--rd-text-primary)' }}>Preliminary alignment view.</b> {index.preliminary.notice}{' '}
        <Link to={`${index.preliminary.help_route}?index=${index.id}`} className="rd-link">How this is scored →</Link>
      </p>
    </div>
  )
}

export function PreliminaryChip({ index, label = 'PRELIMINARY' }: { index: IndexDef; label?: string }) {
  if (!isPreliminary(index)) return null
  return <Chip tone="warn" style={{ fontWeight: 700, letterSpacing: '0.06em' }}>{label}</Chip>
}
